package org.example.zone360.pages.players_Details.playerRecentAssessment

import org.example.zone360.components.debugPrintln

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import org.example.zone360.utils.assessmentRating
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaCalendarDay
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronDown
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronUp
import com.varabyte.kobweb.silk.components.icons.fa.FaCommentDots
import com.varabyte.kobweb.silk.components.icons.fa.FaLightbulb
import com.varabyte.kobweb.silk.components.icons.fa.FaStar
import com.varabyte.kobweb.silk.components.icons.fa.FaUser
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.utils.getPlayerAssessment
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomDivider
import org.example.zone360.components.CustomPagination
import org.example.zone360.components.StarRating
import org.example.zone360.components.formatSessionDate
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetClubPlayerAssessmentData
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.GetSinglePlayerData
import org.example.zone360.pages.dashboard.SectionTitle
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Res
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun PlayersRecentAssessment(
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    userId: String,
    message: (String) -> Unit,
    getPlayerInfo: GetSinglePlayerData,
    setPlayerInfo: (GetSinglePlayerData) -> Unit,
    toastMessageCall: (String) -> Unit,
    noOverFlow: (Boolean) -> Unit,
    seasonId: String,
    sessionData: (List<GetSessionsData>) -> Unit,
) {

    val playerAssessment = remember { mutableStateListOf<GetClubPlayerAssessmentData>() }
    val scope = rememberCoroutineScope()
    var inviteCoach by remember { mutableStateOf(false) }
    var requestAssessment by remember { mutableStateOf(false) }
    val getSessions = remember { mutableStateListOf<GetSessionsData>() }
    var sessionSingleData by remember { mutableStateOf(GetSessionsData()) }

    var playerRecommendation by remember { mutableStateOf(false) }
    var allRecommendations by remember { mutableStateOf(false) }
    var isExpanding by remember { mutableStateOf(false) }

    var showContent by remember { mutableStateOf(false) }
    var isAnimatingOut by remember { mutableStateOf(false) }

    LaunchedEffect(isExpanding) {
        if (isExpanding) {
            delay(50)
            showContent = true
            isAnimatingOut = false
        } else {
            isAnimatingOut = true
            delay(50)
            showContent = false
            isAnimatingOut = false
        }
    }
    if (allRecommendations) {
        AllAssessmentRecommendation(
            onDialogDismiss = { allRecommendations = false },
            modalNumber = 4,
            breakpoint = breakpoint,
            data = sessionSingleData,
            userId = userId
        )
    }
    if (playerRecommendation) {
        PlayersRecommendation(
            onDialogDismiss = { playerRecommendation = false },
            modalNumber = 3,
            breakpoint = breakpoint,
            data = sessionSingleData,
            userId = userId,
            allSessions = getSessions
        )
    }

    if (requestAssessment) {
        RequestAssessment(
            onDialogDismiss = { requestAssessment = false },
            modalNumber = 2,
            breakpoint = breakpoint,
            toastMessageCall = message,
            getPlayerInfo = getPlayerInfo,
            setPlayerInfo = setPlayerInfo,
            userId = userId

        )
    }
    if (inviteCoach) {
        InviteCoach(
            onDialogDismiss = { inviteCoach = false },
            modalNumber = 1,
            breakpoint = breakpoint,
            toastMessageCall = message,
            getPlayerInfo = getPlayerInfo,
            userId = userId

        )
    }


    LaunchedEffect(userId, seasonId) {
        try {
            val getSessionsResponse = getPlayerAssessment(
                playerID = userId,
                domainType = "soccer",
                language = "en",
                seasonID = AppGlobal.selectedSeasonId
            )

            val data = getSessionsResponse.data

            val sortedData = data.sortedByDescending { it.rating }
            getSessions.clear()
            getSessions.addAll(sortedData)
            sessionData(sortedData)

            if (sortedData.isNotEmpty()) {
                sessionSingleData = sortedData.first()
            } else {
                debugPrintln("No data to show.")
                message("No recent assessments available.")
            }

        } catch (e: Exception) {
            debugPrintln("Error fetching assessment data: ${e.message}")
            message("Failed to fetch recent assessments.")
        }

    }

    val modifier = if (breakpoint >= Breakpoint.MD) Modifier.height(400.px) else Modifier
    Box(
        modifier = modifier
            .fillMaxWidth()
            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .borderRadius(15.px)
            .overflow(
                overflowY = Overflow.Hidden,
                overflowX = Overflow.Auto
            )
            .boxShadow(
                offsetY = 1.px,
                blurRadius = 3.px,
                color = sitePalette.boxShadowColor.rgb
            )
            .border(1.px, style = LineStyle.Solid, color = sitePalette.coachDetailsBoxBorder.rgb)
    ) {
        Column(
            modifier = Modifier
//                .fillMaxWidth()
                .width(100.percent)
                .fillMaxHeight()
        ) {
            Box(modifier = Modifier.width(98.8.percent)) {
                Column(
                    modifier = Modifier.fillMaxWidth()
                        .padding(16.px)
                ) {
                    if (breakpoint >= Breakpoint.MD) {
                        Row(
                            modifier = Modifier.margin(topBottom = 10.px).fillMaxWidth()
                                .flexWrap(FlexWrap.Wrap),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.SpaceBetween
                        ) {
                            SectionTitle("Recent Assessments")

                            Row(modifier = Modifier.gap(12.px)) {
//                            CommonButton(
//                                text = "Invite Coach",
//                                textSpanColor = sitePalette.coachInfoTextColor.rgb,
//                                backgroundColor = sitePalette.lightGrey.rgb,
//                                textSpanFontWeight = 500,
//                                icon = {
//                                       Image(src = Res.Images.invite_coach)
//                                },
//                                onCLick = {
//                                    inviteCoach = true
//                                },
//                                width = 138.px,
//                                height = 36.px
//                            )
                                Box(modifier = Modifier.position(Position.Relative)) {
                                    CommonButton(
                                        text = "Request Assessment",
                                        textSpanColor = sitePalette.coachInfoTextColor.rgb,
                                        backgroundColor = sitePalette.lightGrey.rgb,
                                        textSpanFontWeight = 500,
                                        icon = {
                                            Image(src = Res.Images.portfolio_report)
                                        },
                                        onCLick = {
                                            requestAssessment = true

                                        },
                                        width = 195.px,
                                        height = 36.px
                                    )
                                }
                                if (getSessions.isNotEmpty()) {
                                    Box(
                                        modifier = Modifier.position(Position.Relative)
                                            .onClick {}) {
                                        CommonButton(
                                            text = "All Recommendations",
                                            textSpanColor = sitePalette.coachInfoTextColor.rgb,
                                            backgroundColor = sitePalette.lightGrey.rgb,
                                            textSpanFontWeight = 500,
                                            onCLick = {

                                                allRecommendations = true


                                            },
                                            width = 195.px,
                                            height = 36.px
                                        )
                                    }
                                }
                            }

                        }

                        Row(
                            modifier = Modifier.fillMaxWidth()
                                .backgroundColor(sitePalette.lightGrey.rgb)
                                .height(50.px),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Row(
                                modifier = Modifier.fillMaxWidth(98.5.percent)
                                    .padding(leftRight = 8.px),
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.SpaceBetween
                            ) {
                                FieldTitleTextNormalSimple(
                                    text = "Date",
                                    width = 140.px,
                                    fontWeight = 500,
                                    fontSize = 15.px
                                )
                                FieldTitleTextNormalSimple(
                                    text = "Coach Name",
                                    width = 200.px,
                                    fontWeight = 500,
                                    fontSize = 15.px
                                )
                                FieldTitleTextNormalSimple(
                                    text = "Key Insight",
                                    width = 200.px,
                                    fontWeight = 500,
                                    fontSize = 15.px,
                                    textAlign = TextAlign.Center
                                )
                                FieldTitleTextNormalSimple(
                                    text = "Rating",
                                    width = 200.px,
                                    fontWeight = 500,
                                    fontSize = 15.px,
                                    textAlign = TextAlign.Center
                                )

                                FieldTitleTextNormalSimple(
                                    text = "Recommendations",
                                    width = 120.px,
                                    fontWeight = 500,
                                    fontSize = 15.px
                                )
                            }
                        }
                        Column(
                            modifier = Modifier.fillMaxWidth()
                                .maxHeight(230.px)
                                .overflow(overflowY = Overflow.Auto, overflowX = Overflow.Hidden)
                        ) {

                            getSessions.forEach { data ->
                                key(data.userId) {
                                    var starRating by remember { mutableStateOf(data.rating) }
                                    val sameCoach = AppGlobal.userData.uid == data.userId
//                                only show coach who has assessment
//          if (data.wordCount > 0){
                                    Row(
                                        modifier = Modifier.fillMaxWidth()
                                            .padding(leftRight = 8.px, topBottom = 5.px),
                                        verticalAlignment = Alignment.CenterVertically,
                                        horizontalArrangement = Arrangement.SpaceBetween
                                    ) {
                                        FieldTitleTextNormalSimple(
                                            text = data.sessionDateTime.formatSessionDate(),
                                            width = 140.px,
                                            fontWeight = 400,
                                            fontSize = 14.px
                                        )
                                        FieldTitleTextNormalSimple(
                                            text = data.coachName,
                                            width = 200.px,
                                            fontWeight = 400,
                                            fontSize = 14.px
                                        )
                                        FieldTitleTextNormalSimple(
                                            text = data.keyInsights.replace("Three words:", "")
                                                .ifEmpty { "-" },
                                            width = 200.px,
                                            fontWeight = 400,
                                            fontSize = 14.px,
                                            textAlign = TextAlign.Center

                                        )

                                        Box(
                                            modifier = Modifier.width(200.px),
                                            contentAlignment = Alignment.Center
                                        ) {
                                            StarRating(
                                                rating = starRating,
                                                cursor = sameCoach,
                                                onRatingChanged = { newRating ->
                                                    if (!sameCoach) {
                                                        toastMessageCall("Coach can only rate their own session.")
                                                        showToast("toastError")
                                                        return@StarRating
                                                    }
                                                    starRating = newRating
                                                    scope.launch {
                                                        try {
                                                            val response = assessmentRating(
                                                                rating = newRating.toString(),
                                                                userID = data.userId,
                                                                coachName = data.coachName,
                                                                sessionID = data.sessionId,
                                                                organization = AppGlobal.userData.organization
                                                            )
                                                            // Update the reactive list itself
                                                            val index =
                                                                getSessions.indexOfFirst { it.sessionId == data.sessionId }
                                                            if (index != -1) {
                                                                getSessions[index] =
                                                                    getSessions[index].copy(rating = newRating)
                                                            }

                                                            // Now compute the average from the updated list
                                                            val averageRating =
                                                                getSessions.map { it.rating }
                                                                    .average()

                                                            // Update the player info state
                                                            setPlayerInfo(getPlayerInfo.copy(rating = averageRating))

                                                        } catch (e: Exception) {
                                                            debugPrintln("Failed to submit rating: ${e.message}")
                                                        }
                                                    }

                                                }
                                            )

                                        }

                                        Box(
                                            modifier = Modifier.width(120.px),
                                            contentAlignment = Alignment.Center
                                        ) {
                                            CommonButton(
                                                text = "View",
                                                textSpanColor = sitePalette.viewText.rgb,
                                                backgroundColor = sitePalette.viewButtonBackground.rgb,
                                                width = 64.px,
                                                height = 28.px,
                                                pointerCursor = true,
                                                onCLick = {

                                                    playerRecommendation = true
                                                    sessionSingleData = data


                                                },
                                            )
                                        }

                                    }
                                    CustomDivider()
//                        }
                                }
                            }
                        }
                    } else {
                        var currentPage by remember { mutableStateOf(0) }
                        val sessionsPerPage = 1
                        val totalPages = (getSessions.size + sessionsPerPage - 1) / sessionsPerPage

                        Row(
                            modifier = Modifier.margin(topBottom = 10.px).fillMaxWidth()
                                .flexWrap(FlexWrap.Wrap),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.SpaceBetween
                        ) {
                            SectionTitle("Recent Assessments")

                            Row(
                                modifier = Modifier.gap(12.px).flexWrap(FlexWrap.Wrap),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Box(modifier = Modifier.position(Position.Relative)) {
                                    CommonButton(
                                        text = "Request Assessment",
                                        textSpanColor = sitePalette.coachInfoTextColor.rgb,
                                        backgroundColor = sitePalette.lightGrey.rgb,
                                        textSpanFontWeight = 500,
                                        icon = { Image(src = Res.Images.portfolio_report) },
                                        onCLick = {
                                            noOverFlow(true)
                                            requestAssessment = true
                                        },
                                        width = 195.px,
                                        height = 36.px
                                    )
                                }

                                if (getSessions.isNotEmpty()) {
                                    Box(modifier = Modifier.position(Position.Relative)) {
                                        CommonButton(
                                            text = "All Recommendations",
                                            textSpanColor = sitePalette.coachInfoTextColor.rgb,
                                            backgroundColor = sitePalette.lightGrey.rgb,
                                            textSpanFontWeight = 500,
                                            onCLick = {
                                                noOverFlow(true)

                                                allRecommendations = true
                                            },
                                            width = 195.px,
                                            height = 36.px
                                        )
                                    }
                                }
                            }
                        }

                        HorizontalDivider(Modifier.fillMaxWidth())

                        if (getSessions.isNotEmpty()) {
                            val session = getSessions[currentPage]

                            key(session.sessionId) {
                                Column(
                                    modifier = Modifier.fillMaxWidth().margin(topBottom = 10.px),
                                    verticalArrangement = Arrangement.Center
                                ) {
                                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                                        Row(
                                            modifier = Modifier.width(40.percent),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            FaCalendarDay(
                                                modifier = Modifier.color(sitePalette.primary.rgb).margin(right = 8.px, bottom = 3.px, left = 2.px),
                                                size = IconSize.SM
                                            )
                                            FieldTitleTextNormalSimple(
                                                text = "Date:",
                                                fontSize = 15.px,
                                                fontWeight = 550,
                                            )
                                        }
                                        FieldTitleTextNormalSimple(
                                            text = session.sessionDateTime.formatSessionDate(),
                                            fontSize = 15.px,
                                            fontWeight = 400,
                                            width = 60.percent,
                                            color = sitePalette.titleColor.rgb
                                        )
                                    }

                                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                                        Row(
                                            modifier = Modifier.width(40.percent),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            FaStar(
                                                modifier = Modifier.color(sitePalette.primary.rgb).margin(right = 6.px),
                                                size = IconSize.SM
                                            )
                                            FieldTitleTextNormalSimple(
                                                text = "Rating:",
                                                fontSize = 15.px,
                                                fontWeight = 500,
                                            )
                                        }

                                        val sameCoach = AppGlobal.userData.uid == session.userId

                                        StarRating(
                                            rating = session.rating,
                                            cursor = sameCoach,
                                            onRatingChanged = { newRating ->
                                                if (!sameCoach) {
                                                    toastMessageCall("Coach can only rate their own session.")
                                                    showToast("toastError")
                                                    return@StarRating
                                                }

                                                scope.launch {
                                                    try {
                                                        val response = assessmentRating(
                                                            rating = newRating.toString(),
                                                            userID = session.userId,
                                                            coachName = session.coachName,
                                                            sessionID = session.sessionId,
                                                            organization = AppGlobal.userData.organization
                                                        )

                                                        val updatedSessions = getSessions.map {
                                                            if (it.sessionId == session.sessionId) it.copy(
                                                                rating = newRating
                                                            ) else it
                                                        }

                                                        val averageRating =
                                                            if (updatedSessions.isNotEmpty())
                                                                updatedSessions.map { it.rating }
                                                                    .average()
                                                            else 0.0

                                                        setPlayerInfo(getPlayerInfo.copy(rating = averageRating))
                                                    } catch (e: Exception) {
                                                        debugPrintln("Failed to submit rating: ${e.message}")
                                                        toastMessageCall("Failed to submit rating.")
                                                        showToast("toastError")
                                                    }
                                                }
                                            }
                                        )
                                    }

                                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                                        Row(
                                            modifier = Modifier.width(40.percent),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            FaUser(
                                                modifier = Modifier.color(sitePalette.primary.rgb).margin(right = 6.px),
                                                size = IconSize.SM
                                            )
                                            FieldTitleTextNormalSimple(
                                                text = "Coach Name:",
                                                fontSize = 15.px,
                                                fontWeight = 500,
                                            )
                                        }
                                        FieldTitleTextNormalSimple(
                                            text = session.coachName,
                                            fontSize = 15.px,
                                            fontWeight = 400,
                                            width = 60.percent,
                                            color = sitePalette.titleColor.rgb
                                        )
                                    }

                                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                                        Row(
                                            modifier = Modifier.width(40.percent),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            FaLightbulb(
                                                modifier = Modifier.color(sitePalette.primary.rgb).margin(right = 6.px),
                                                size = IconSize.SM
                                            )
                                            FieldTitleTextNormalSimple(
                                                text = "Key Insight:",
                                                fontSize = 15.px,
                                                fontWeight = 500,
                                            )
                                        }
                                        FieldTitleTextNormalSimple(
                                            text = session.keyInsights.replace("Three words:", "")
                                                .ifEmpty { "-" },
                                            fontSize = 15.px,
                                            fontWeight = 400,
                                            width = 60.percent,
                                            color = sitePalette.titleColor.rgb
                                        )
                                    }
                                   // Outer card container - wrap karo dono ko
                                    Box(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .border(
                                                1.px,
                                                LineStyle.Solid,
                                                sitePalette.selectedSessionBackgroundBorder.rgb
                                            )
                                            .borderRadius(8.px)
                                            .overflow(Overflow.Hidden)
                                            .margin(bottom = 10.px)
                                    ) {
                                        Column(modifier = Modifier.fillMaxWidth()) {
                                            Box(
                                                modifier = Modifier
                                                    .fillMaxWidth()
                                                    .backgroundColor(sitePalette.selectedSessionBackground.rgb)
                                                    .then(
                                                        if (isExpanding) Modifier.borderBottom(
                                                            0.5.px, LineStyle.Solid, sitePalette.selectedSessionBackgroundBorder.rgb
                                                        ) else Modifier
                                                    )
                                                    .padding(topBottom = 6.px, leftRight = 10.px)
                                                    .cursor(Cursor.Pointer)
                                                    .onClick { isExpanding = !isExpanding }
                                            ) {
                                                Row(
                                                    modifier = Modifier.fillMaxWidth(),
                                                    verticalAlignment = Alignment.CenterVertically,
                                                    horizontalArrangement = Arrangement.SpaceBetween
                                                ) {
                                                    Row(
                                                        verticalAlignment = Alignment.CenterVertically,
                                                        modifier = Modifier.gap(8.px)
                                                    ) {
                                                        Box(
                                                            modifier = Modifier
                                                                .size(24.px)
                                                                .borderRadius(6.px)
                                                                .backgroundColor(sitePalette.primary.rgb),
                                                            contentAlignment = Alignment.Center
                                                        ) {
                                                            FaCommentDots(
                                                                modifier = Modifier.color(Palette.White.rgbLight),
                                                                size = IconSize.SM
                                                            )
                                                        }
                                                        FieldTitleTextNormalSimple(
                                                            text = "Recommendations",
                                                            fontSize = 13.px,
                                                            fontWeight = 500,
                                                            color = sitePalette.primary.rgb
                                                        )
                                                    }
                                                    if (isExpanding) {
                                                        FaChevronUp(
                                                            size = IconSize.XS,
                                                            modifier = Modifier.cursor(Cursor.Pointer)
                                                                .color(sitePalette.primary.rgb)
                                                        )
                                                    } else {
                                                        FaChevronDown(
                                                            size = IconSize.XS,
                                                            modifier = Modifier.cursor(Cursor.Pointer)
                                                                .color(sitePalette.primary.rgb)
                                                        )
                                                    }
                                                }
                                            }

                                            // Expanding content
                                            if (showContent) {
                                                Row(
                                                    modifier = Modifier
                                                        .fillMaxWidth()
                                                        .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                                                        .opacity(if (isAnimatingOut) 0 else 1)
                                                        .transition(
                                                            Transition.of("transform", 250.ms, AnimationTimingFunction.EaseInOut)
                                                        )
                                                        .padding(topBottom = 12.px, leftRight = 12.px)
                                                        .styleModifier { property("align-items", "stretch") },
                                                    verticalAlignment = Alignment.Top
                                                ) {
                                                    Column(
                                                        modifier = Modifier.weight(1).gap(10.px)
                                                    ) {
                                                        FieldTitleTextNormalSimple(
                                                            text = session.summary.trim(),
                                                            fontSize = 12.px,
                                                            width = 100.percent,
                                                            textAlign = TextAlign.Justify,
                                                            color = sitePalette.titleColor.rgb
                                                        )
                                                    }
                                                }
                                            }

                                        }
                                    }
//                                    Row(
//                                        modifier = Modifier.fillMaxWidth().margin(bottom = 10.px),
//                                        verticalAlignment = Alignment.CenterVertically,
//                                    )
//                                    {
//                                        FieldTitleTextNormalSimple(
//                                            text = "Recommendations",
//                                            fontSize = 15.px,
//                                            fontWeight = 500,
//                                            marginRight = 10.px
//                                        )
//                                        if (isExpanding) {
//                                            FaChevronUp(
//                                                size = IconSize.XS,
//                                                modifier = Modifier.cursor(Cursor.Pointer)
//                                                    .onClick {
//                                                        isExpanding = false
//                                                    }
//                                            )
//
//                                        } else {
//                                            FaChevronDown(
//                                                size = IconSize.XS,
//                                                modifier = Modifier.cursor(Cursor.Pointer)
//                                                    .onClick { isExpanding = true })
//                                        }
//                                    }

//                                    if (isExpanding) {
//                                        Column(modifier = Modifier.fillMaxWidth()) {
//                                            FieldTitleTextNormalSimple(
//                                                text = session.summary.trim(),
//                                                fontSize = 13.px,
//                                                width = 100.percent,
//                                                textAlign = TextAlign.Justify
//                                            )
//                                        }
//                                    }

                                    if (totalPages > 1) {
                                        Row(
                                            modifier = Modifier
                                                .fillMaxWidth()
                                                .margin(bottom = 10.px),
                                            verticalAlignment = Alignment.CenterVertically,
                                            horizontalArrangement = Arrangement.End
                                        ) {
                                            CustomPagination(
                                                currentPage = currentPage,
                                                totalPages = totalPages,
                                                onPageChange = { newPage -> currentPage = newPage },
                                                sitePalette = sitePalette,
                                                leftRightPadding = 0.px
                                            )
                                        }
                                    }
                                }
                            }
                        } else {
                            // Optional: no session fallback UI
                            Column(modifier = Modifier.fillMaxWidth().padding(10.px)) {
                                FieldTitleTextNormalSimple(
                                    text = "No recent assessments available.",
                                    fontSize = 14.px,
                                    fontWeight = 500,
                                    color = sitePalette.titleColor.rgb
                                )
                            }
                        }
                    }

                }
            }
        }
    }
}
